import { render, staticRenderFns } from "./Cashbill.vue?vue&type=template&id=606c2c78&"
import script from "./Cashbill.vue?vue&type=script&lang=js&"
export * from "./Cashbill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports